import React from 'react';
import FlipMove from 'react-flip-move';
import Modal from 'shared/components/misc/modal.jsx';
import UIRegions from 'shared/constants/UIRegions';
import { DisplayTypes } from 'shared/constants/FlowConstants';
import { Grid, Row, Col, Button } from 'bootstrap';
import GuestPassActions from 'flux/actions/GuestPassActions';
import ModalActions from 'flux/actions/ModalActions';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import CuesheetColumnActions from 'flux/actions/cuesheet/CuesheetColumnActions';
import EventActions from 'flux/actions/EventActions';
import CuesheetDataHelper from 'flux/stores/cuesheet/CuesheetDataHelper';
import { ToggleSwitch } from '@shoflo-rundown/polymer.legacy';
import role from 'shared/lib/role';
import ToastActions from 'flux/actions/ToastActions';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { isGlobalElementManager } from 'main/components/show/cuesheet/cuesheetViewHelper';

export default React.createClass({
  displayName: 'GuestPassModal',

  getInitialState() {
    return {
      defineCustomColumns: false,
    };
  },

  render() {
    const {
      modalType,
      teamId,
      eventId,
      showId,
      title,
      description,
    } = this.props;

    const { host, protocol } = window.location;
    const eventUrl = `${protocol}//${host}/teams/${teamId}/events/${eventId}/guest`;
    const showUrl = `${protocol}//${host}/teams/${teamId}/events/${eventId}/shows/${showId}/guest`;
    const guestUrl = showId ? showUrl : eventUrl;
    const inputNode = this._getInputNode(host, guestUrl);
    const guestPassMessage = description;

    let guestPassNode = showId
      ? this._getGuestPassShowNode()
      : this._getGuestPassEventNode();

    if (!this._hasEventAdminRole()) guestPassNode = null;

    return (
      <Modal
        name={modalType}
        title={title}
        className="guest-pass-modal"
        closeButton
      >
        <Grid fluid>
          <Row>
            <Col md={24}>{guestPassMessage}</Col>
          </Row>
          <Row>
            <Col md={24}>{guestPassNode}</Col>
          </Row>
          <Row>
            <Col md={24}>{inputNode}</Col>
          </Row>
          <Row>
            <Col md={24}>{this._getGuestPassButtons(guestUrl)}</Col>
          </Row>
          <Row>
            <Col md={24}>{this._getShowListNode(host)}</Col>
          </Row>
          <Row>
            <Col md={24}>{this._getCustomizableGuestColumns()}</Col>
          </Row>
          <Row>
            <Col md={24}>
              <Button className="guest-done-btn" onClick={this._handleOnHide}>
                Done
              </Button>
            </Col>
          </Row>
        </Grid>
      </Modal>
    );
  },

  _defineCustomColumnsToggle() {
    const { defineCustomColumns } = this.state;
    this.setState({ defineCustomColumns: !defineCustomColumns });
  },

  _hasEventAdminRole() {
    const { teamId, eventId, user } = this.props;

    if (!user) return;

    return role.hasEventAdminRole(user, teamId, eventId);
  },

  _selectText() {
    const input = document.getElementById('urlText');
    input.focus();
    input.setSelectionRange(0, input.value.length);
  },

  _copyToClipBoard() {
    if (this._linkText !== null) {
      this._linkText.focus();
      document.execCommand('copy');
      ToastActions.copied('Link copied to clipboard');
    }
  },

  _getCopyLinkNode() {
    /**
     * Node does not render for Safari. Because Chrome often includes 'Safari' in its user agent,
     * browsers are only excluded if they contain 'Safari' AND don't contain 'Chrome'
     */
    if (
      navigator.userAgent.indexOf('Safari') !== -1 &&
      navigator.userAgent.indexOf('Chrome') === -1
    ) {
      return null;
    }
    return (
      <Button onClick={this._copyToClipBoard} className="guest-pass-btn ">
        Copy Link
      </Button>
    );
  },

  _getInputNode(host, guestUrl) {
    /**
     * Tooltip only renders for Safari. Because Chrome often includes 'Safari' in its user agent,
     * browsers are only included if they contain 'Safari' AND don't contain 'Chrome'
     */
    let inputField = this._getInputField(host, guestUrl);

    if (
      navigator.userAgent.indexOf('Safari') != -1 &&
      navigator.userAgent.indexOf('Chrome') == -1
    ) {
      return (
        <WithTooltip
          delay={1000}
          tip={TooltipConstants.ManualCopyLink}
          placement="top"
        >
          <span>{inputField}</span>
        </WithTooltip>
      );
    }

    return <span>{inputField}</span>;
  },

  _getInputField(host, guestUrl) {
    const { showId } = this.props;

    let labelText = showId ? ' Guest Pass Url' : ' Event Guest Pass Url';

    return (
      <div>
        <input
          readOnly
          label={labelText}
          key={this._linkText}
          type="text"
          ref={(ref) => (this._linkText = ref)}
          id="urlText"
          value={guestUrl}
          autoFocus
          onFocus={this._selectText}
          className="guest-pass-input"
        />
      </div>
    );
  },

  _getGuestPassButtons(guestUrl) {
    const { showId } = this.props;

    let copyLinkNode = this._getCopyLinkNode();
    let customColumnButton =
      showId && !isGlobalElementManager() ? (
        <div
          className="guest-pass-define-columns-btn"
          onClick={() => this._defineCustomColumnsToggle()}
        >
          {!this.state.defineCustomColumns ? 'Set Visible Columns' : 'Hide'}
        </div>
      ) : null;

    return (
      <div className="guest-pass-btn-wrappers">
        <Button
          onClick={this._handleOnHide}
          className="guest-pass-btn guest-pass-close-btn"
        >
          Close
        </Button>
        {copyLinkNode}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={guestUrl}
          className="btn btn-default guest-pass-btn guest-pass-tab-btn"
        >
          Open In New Tab
        </a>
        {customColumnButton}
      </div>
    );
  },

  _getCustomizableGuestColumns() {
    const {
      showId,
      fullColumns,
      columnOrderGuest,
      columnsGuestPass,
    } = this.props;

    if (!showId || isGlobalElementManager()) return;
    if (!fullColumns || !columnOrderGuest || !columnsGuestPass) return;

    return this.state.defineCustomColumns ? (
      <div className="guest-modal-columns-list">
        {this._getVisibleColumns()}
        {this._getHiddenColumns()}
      </div>
    ) : null;
  },

  _getColumnHideToggle(column) {
    const { columnsGuestPass } = this.props;
    let hideColumn = false;

    if (columnsGuestPass)
      hideColumn = columnsGuestPass.find(
        (guestCol) => guestCol.get('_id') === column.get('_id'),
      )
        ? true
        : false;

    return (
      <div className="guest-modal-column-switch">
        <ToggleSwitch
          on={hideColumn}
          onClick={() => {
            if (hideColumn) {
              CuesheetColumnActions.deleteColumnGuestPass(column.get('_id'));
            } else {
              CuesheetColumnActions.addColumnGuestPass(column.get('_id'));
            }
          }}
        />
      </div>
    );
  },

  _getVisibleColumns() {
    const { columnsGuestPass } = this.props;
    let index = 0;

    return columnsGuestPass.map((column) => {
      return (
        <FlipMove
          enterAnimation="accordianVertical"
          leaveAnimation="accordianVertical"
        >
          <div className="guest-modal-column clearfix" key={index++}>
            <div className="guest-modal-column-title">
              {column.get('title')}
            </div>
            {this._getColumnOrderNode(column)}
            {this._getColumnHideToggle(column)}
          </div>
        </FlipMove>
      );
    });
  },

  _getHiddenColumns() {
    const { fullColumns, columnsGuestPass } = this.props;

    const guestPassKeys = Object.keys(columnsGuestPass.toJS());
    const fullColumnKeys = Object.keys(fullColumns.toJS());

    let cleanedFullColumns = fullColumns;

    if (fullColumnKeys && guestPassKeys) {
      fullColumnKeys.forEach((columnId) => {
        if (guestPassKeys.includes(columnId)) {
          cleanedFullColumns = cleanedFullColumns.delete(columnId);
        }
      });
    }

    return cleanedFullColumns.map((column) => {
      return (
        <div className="guest-modal-column clearfix">
          <div className="guest-modal-column-title">{column.get('title')}</div>
          {this._getColumnHideToggle(column)}
        </div>
      );
    });
  },

  _getColumnOrderNode(column) {
    const columnId = column.get('_id');

    return (
      <div className="guest-modal-column-order">
        <Icon
          name="arrow-circle-o-down"
          onClick={(e) => {
            e.stopPropagation();
            CuesheetColumnActions.moveGuestColumnRight(columnId);
          }}
        />
        <Icon
          name="arrow-circle-o-up"
          onClick={(e) => {
            e.stopPropagation();
            CuesheetColumnActions.moveGuestColumnLeft(columnId);
          }}
        />
      </div>
    );
  },

  _getGuestPassEventNode() {
    const { event, teamId, eventId, title } = this.props;

    if (!event) return;

    let guestPass = event.get('guestPass');

    return (
      <div className="guest-pass-modal-switch">
        <div className="guest-pass-modal-switch-title">{title}</div>
        <ToggleSwitch
          on={guestPass}
          onClick={() => {
            const newVal = !guestPass;
            EventActions.updateField(teamId, eventId, 'guestPass', newVal);
          }}
        />
      </div>
    );
  },

  _getGuestPassShowNode() {
    const { show, teamId, eventId, showId } = this.props;

    const showState = show;

    if (!showState || !showId) return;

    let disableGuestPass = !showState.get('disableGuestPass');

    return (
      <div className="guest-pass-modal-switch">
        <div className="guest-pass-modal-switch-title">Guest Pass</div>
        <ToggleSwitch
          on={disableGuestPass}
          onClick={() => {
            GuestPassActions.toggleGuestPass(
              teamId,
              eventId,
              showId,
              disableGuestPass,
              showState.get('displayType'),
            );
          }}
        />
      </div>
    );
  },

  _handleOnHide() {
    ModalActions.hide(UIRegions.GuestPass);
  },

  _updateGuestPassColumns(columns, columnOrder) {
    const sortedColumns = CuesheetDataHelper.getSortedColumns(
      columns,
      columnOrder,
    );
    return sortedColumns;
  },

  _getGuestPassShowListToggle(host) {
    const { teamId, eventId, showList } = this.props;

    if (!showList) return;

    return showList.map((show) => {
      let capsDisplayType = '';

      if (show.get('displayType') === DisplayTypes.show)
        capsDisplayType = 'Show';
      if (show.get('displayType') === DisplayTypes.list)
        capsDisplayType = 'List';
      if (show.get('displayType') === DisplayTypes.schedule)
        capsDisplayType = 'Schedule';
      if (show.get('displayType') === DisplayTypes.globalElementContainer)
        capsDisplayType = 'Element Set';

      const urlText = `View ${capsDisplayType}`;
      const disableGuestPass = !show.get('disableGuestPass');
      const showUrl = `https://${host}/teams/${teamId}/events/${eventId}/shows/${show.get(
        '_id',
      )}/guest`;
      const externalLink = (
        <a
          className="pointer"
          target="_blank"
          rel="noopener noreferrer"
          href={showUrl}
        >
          {urlText}
        </a>
      );

      return (
        <div className="guest-modal-column clearfix">
          <div className="guest-modal-column-title">
            {show.get('title') + '  '}
          </div>
          <div className="guest-modal-column-link">
            {disableGuestPass ? externalLink : null}
          </div>
          <div className="guest-modal-column-switch">
            <ToggleSwitch
              on={!show.get('disableGuestPass')}
              onClick={() => {
                GuestPassActions.toggleGuestPass(
                  teamId,
                  eventId,
                  show.get('_id'),
                  disableGuestPass,
                  show.get('displayType'),
                );
              }}
            />
          </div>
        </div>
      );
    });
  },

  _getShowListNode(host) {
    if (this.props.showId) return;

    return (
      <div className="guest-modal-columns-list">
        {this._getGuestPassShowListToggle(host)}
      </div>
    );
  },
});
